import type { Translations } from '../../../types'
import profilePreferencesMessages from './preferences'
import profilePanelsMessages from './panels'
import profileHeroMessages from './hero'
import profileContactMessages from './contact'
import profileToastMessages from './toast'
import profileSecurityMessages from './security'
import profileSessionsMessages from './sessions'
import profileTeamMessages from './team'
import profileUserEditorMessages from './userEditor'
import profileDangerMessages from './danger'

const profileMessages: Translations = {
  ...profilePreferencesMessages,
  ...profilePanelsMessages,
  ...profileHeroMessages,
  ...profileContactMessages,
  ...profileToastMessages,
  ...profileSecurityMessages,
  ...profileSessionsMessages,
  ...profileTeamMessages,
  ...profileUserEditorMessages,
  ...profileDangerMessages,
}

export default profileMessages
